export default __webpack_public_path__ + "locales/sr-Cyrl-RS/FormGallery.json?hash=c872b3977b3e27c50a46981acee0a1e8";